import React from 'react';

import {
  FilterButton,
  FilterButtonWrapper,
} from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getStockCarList } from '@/store/reducers/cars-stock';

import { ShowCarsButtonProps } from './types';

function ShowCarsButton({ onClick }: ShowCarsButtonProps) {
  const carListCount = useTypedSelector(getStockCarList)?.meta?.count;

  const handleFilterButtonClick = () => {
    onClick?.();
  };

  return (
    <FilterButtonWrapper>
      <FilterButton onClick={handleFilterButtonClick}>
        Посмотреть авто {carListCount ? `(${carListCount})` : ''}
      </FilterButton>
    </FilterButtonWrapper>
  );
}

export default ShowCarsButton;
